import React, { useState } from 'react';
import { SendIcon, CheckIcon, AlertCircleIcon } from 'lucide-react';
const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simple email validation
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }
    // Simulate submission
    setSubmitted(true);
    setError('');
    setEmail('');
    // Reset after 5 seconds
    setTimeout(() => {
      setSubmitted(false);
    }, 5000);
  };
  return <section id="newsletter" className="py-16 bg-black/60 backdrop-blur-sm border-t border-purple-500/20" data-id="element-545">
      <div className="container mx-auto px-4 sm:px-6 max-w-4xl" data-id="element-546">
        <div className="text-center mb-8" data-id="element-547">
          <h2 className="text-3xl md:text-4xl font-bold font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 inline-block mb-4" data-id="element-548">
            JOIN OUR UNIVERSE
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto" data-id="element-549">
            Subscribe to our newsletter for exclusive updates, early access to
            new releases, and special offers.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="max-w-md mx-auto" data-id="element-550">
          <div className="flex flex-col sm:flex-row gap-3" data-id="element-551">
            <div className="flex-grow relative" data-id="element-552">
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email address" className="w-full px-4 py-3 bg-gray-900/70 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-pink-500 text-white" disabled={submitted} data-id="element-553" />
              {error && <p className="absolute -bottom-6 left-0 text-red-400 text-sm flex items-center" data-id="element-554">
                  <AlertCircleIcon size={14} className="mr-1" data-id="element-555" />
                  {error}
                </p>}
            </div>
            <button type="submit" className={`px-6 py-3 rounded-lg font-medium transition-all duration-300 flex items-center justify-center ${submitted ? 'bg-green-600 text-white' : 'bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-500 hover:to-purple-500 text-white hover:shadow-lg hover:shadow-pink-500/30'}`} disabled={submitted} data-id="element-556">
              {submitted ? <>
                  <CheckIcon size={18} className="mr-2" data-id="element-557" />
                  SUBSCRIBED
                </> : <>
                  <SendIcon size={18} className="mr-2" data-id="element-558" />
                  SUBSCRIBE
                </>}
            </button>
          </div>
        </form>
        <div className="text-center mt-10 text-sm text-gray-400" data-id="element-559">
          By subscribing, you agree to receive updates from Fabric Reality. We
          promise not to spam your inbox.
        </div>
      </div>
    </section>;
};
export default Newsletter;